module.exports = __webpack_public_path__ + "static/media/einstein.402ec6c9.png";